import MuiSlider, { SliderProps as MuiSliderProps } from '@material-ui/core/Slider';
import classNames from 'classnames';
import React, { FC, memo } from 'react';

import Thumb from './components/Thumb/Thumb';
import useStyles from './styles';

export interface SliderProps extends Omit<MuiSliderProps, 'onChange' | 'type'> {
  noBorderRadius?: boolean;
  onChange: (event: React.ChangeEvent<unknown>, value: number | number[]) => void;
}

export const Slider: FC<SliderProps> = ({ min, max, value, step, marks, onChange, noBorderRadius }) => {
  const classes = useStyles();

  return (
    <MuiSlider
      classes={{
        mark: classes.mark,
        markLabel: classes.markLabel,
        rail: classNames(classes.rail, { noBorderRadius }),
        root: classes.root,
        thumb: classes.thumb,
        track: classNames(classes.track, { noBorderRadius }),
      }}
      marks={marks}
      max={max}
      min={min}
      onChange={onChange}
      step={step}
      ThumbComponent={Thumb}
      value={value}
    />
  );
};

export default memo(Slider);
